define([
    'MW/toolstrip/constants/TypeConstants',
    'dojo/i18n!BuildStatus/resources/RTW/nls/buildStatus'
], function (TypeConstants, appL10n) {
    return {
        tag: 'buildstatus.tabGroup',
        type: TypeConstants.TAB_GROUP,
        children: [
            {
                tag: 'buildstatus.home',
                type: TypeConstants.TAB,
                title: appL10n.BuildStatus,
                mnemonic: 'H',
                children: [
                    {
                        tag: 'buildstatus.home.actions',
                        type: TypeConstants.SECTION,
                        title: appL10n.Actions,
                        children: [
                            {
                                tag: 'buildstatus.home.actions.column1',
                                type: TypeConstants.COLUMN,
                                children: [{
                                    tag: 'buildstatus.home.actions.cancelBuild',
                                    type: TypeConstants.PUSH_BUTTON,
                                    actionId: 'cancelBuild',
                                    mnemonic: 'C'
                                }]
                            }
                            /*                             {
                                tag: "buildstatus.home.actions.column2",
                                type: TypeConstants.COLUMN,
                                children: [{
                                    tag: "buildstatus.home.actions.openPA",
                                    type: TypeConstants.PUSH_BUTTON,
                                    actionId: "openPA",
                                    mnemonic: "O"
                                }]
                            } */
                        ]
                    }
                ]
            }]
    };
});
